import React from 'react'
import Header from './Header';
import Sidebar from './Sidebar';
import FlagTabs from './FlagsTabs'
const Flag = (props) => {
    return (
        <div id="wrapper">
                <Sidebar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content-wrap">
                    <Header />
                    <FlagTabs id={props.match.params.id} />
                    </div>
                </div>
            </div>
    )
}

export default Flag
